export const downloadByRequest = (url, filename) => {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  a.click();
  a.remove();
};

export const capitalizeFirstLetter = (val) => {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
};

export const formatDuration = (totalSeconds) => {
  const seconds = totalSeconds == null ? NaN : Number(totalSeconds);
  if (!Number.isFinite(seconds)) return 'Desconocido';
  const totalMinutes = Math.max(0, Math.round(seconds / 60));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return hours > 0 ? `${hours}h ${minutes}min` : `${minutes}min`;
};

export default {};
